const error = {
  api: {
    notfound: 'The requested resource does not exist.',
    unauthorized: 'You are not authorized to access this resource',
    unknown: 'An unexpected error occurred.',
  },
};

export default error;
